import { EventType } from '..';
export const pickUserEvent = (props) => {
    return (({ businessTransactionId, eventName, experienceResult, feature, subFeature, subFeatureLevel2, featureLocation, timeTaken, }) => ({
        type: EventType.User,
        businessTransactionId,
        eventName: eventName,
        experienceResult: experienceResult || true,
        feature,
        subFeature,
        subFeatureLevel2,
        featureLocation,
        timeTaken: timeTaken || 0,
    }))(props || {});
};
//# sourceMappingURL=UserEvent.js.map